<ion-content [scrollEvents]="true" [class]="{ newIonContent: modalType === 'modalNotationLessons' }">
  @if (
    modalType != 'modalConsentPush' &&
    modalType != 'modalMaj1' &&
    modalType != 'modalMaj2' &&
    modalType != 'modalMaj3' &&
    modalType != 'modalStorage2' &&
    modalType != 'modalErrorRetry' &&
    modalType != 'modal500' &&
    modalType != 'modalTimeout' &&
    modalType != 'modalCgaac' &&
    modalType != 'modalNotationLessons'
  ) {
    <button class="close-modal small-clickable" (click)="closeModalPack()">
      <img src="assets/2022/icons/close-off.svg" alt="EnVoitureSimone" height="24" />
    </button>
  } @else if (modalType === 'modalNotationLessons') {
    <evs-top-navigation #topNav [showBackButton]="false" [showCloseButton]="true" (closeClicked)="closeModalPack()"> </evs-top-navigation>
  }

  <!-- DEBUG MODE -->
  @if (modalType == 'debugMode') {
    <div class="modal-debug-mode content-center flex-column">
      <div
        [class]="{
          'margin-bottom-30': !isDesktop,
          'margin-bottom-40': isDesktop,
        }">
        <img src="assets/2026/illustrations/tools.png" alt="Outils clé à molette et tournevis" />
      </div>
      <p><b>Rapport d'erreur</b></p>
      <p>
        En cliquant sur "Démarrer", toutes tes actions seront enregistrées. Merci de reproduire le problème que tu as rencontré et de cliquer sur
        "<b>Envoyer</b>" à la fin de ton enregistrement.
      </p>
      <button class="btn full-width margin-v-10" (click)="launchDebugMode()">Démarrer</button>
      <button class="btn light full-width" (click)="launchCleanStorage()">Réinitialiser mes données</button>
    </div>
  }

  <!-- CGAAC -->
  @if (modalType == 'modalCgaac') {
    <div class="modal-cgaac content-center flex-column">
      <h2>Nous avons mis à jour nos conditions générales</h2>
      <p class="callout margin-v-40">
        Nos conditions générales d’aide à l’apprentissage de la conduite ont été modifiées. Tu dois les accepter pour poursuivre ton utilisation du service.
      </p>
      <button class="btn light white full-width margin-bottom-10" (click)="readConditions()">Lire les conditions</button>
      <button class="btn full-width" (click)="postCgaac()">Accepter</button>
    </div>
  }

  <!-- NOTATION DE LECONS -->
  @if (modalType == 'modalNotationLessons') {
    <div class="modal-notation-lessons">
      <div class="modalContent">
        <div class="infosBloc">
          <evs-avatar type="icon" icon="Star" color="secondary-4"></evs-avatar>
          <div class="textBloc">
            <span class="lessonsInfo"
              >Bonjour {{ student.firstName }},<br />
              tu as {{ counter }}
              @if (counter > 1) {
                leçons
              } @else {
                leçon
              }
              à noter&nbsp;!
            </span>
            @if (counter > 1) {
              <span class="legend">Comment se sont passées tes dernières leçons de conduite&nbsp;?</span>
            } @else {
              <span class="legend">Comment s'est passée ta dernière leçon de conduite&nbsp;?</span>
            }
          </div>
        </div>
        <div class="modalButtonsContainer">
          @if (counter > 1) {
            <p-button label="Noter mes leçons" size="large" [fluid]="true" (click)="openLink('notation')" class="modalButton"></p-button>
          } @else {
            <p-button label="Noter ma leçon" size="large" [fluid]="true" (click)="openLink('notation')" class="modalButton"></p-button>
          }
          <p-button label="Plus tard" severity="contrast" size="large" [fluid]="true" (click)="closeModalPack()" class="transparentButton"></p-button>
        </div>
      </div>
    </div>
  }

  <!-- PUSH NOTIF -->
  @if (modalType == 'modalConsentPush') {
    <div class="modal-push-notif content-center flex-column">
      <div
        [class]="{
          'margin-bottom-30': !isDesktop,
          'margin-bottom-40': isDesktop,
        }">
        <img src="assets/2026/illustrations/push-notif.png" width="219" height="206" alt="EnVoitureSimone" />
      </div>
      <p><b>Une formation aux petits oignons</b></p>
      <p [class.margin-h-20]="isDesktop">
        Active les notifications pour avoir un suivi sur-mesure de ta formation et bénéficier de conseils pour obtenir ton permis
      </p>
      <button class="btn full-width light" [class]="{ 'margin-top-10': !isDesktop, 'margin-top-20': isDesktop }" (click)="closeModalPack()">
        Peut-être plus tard
      </button>
      <button class="btn full-width margin-top-8" (click)="activatePushNotifs()">Activer les notifications</button>
    </div>
  }

  <!-- MARKETING NEW PACK PERMIS CONDUITE -->
  @if (modalType == 'temp') {
    <div class="modal-pack-permis-conduite content-center flex-column">
      <div
        [class]="{
          'margin-bottom-30': !isDesktop,
          'margin-bottom-40': isDesktop,
        }">
        <img src="assets/2026/illustrations/onboarding-offre.png" width="219" height="206" alt="EnVoitureSimone" />
      </div>
      <p><b>Prêt à prendre le volant&nbsp;?</b></p>
      <p [class.margin-h-20]="isDesktop">Avec le Pack Permis, réserve des leçons où tu veux et quand tu veux&nbsp;!</p>
      <button class="btn" [class]="{ 'margin-top-10': !isDesktop, 'margin-top-20': isDesktop }" (click)="openLink('permis')">Acheter le Pack Permis</button>
    </div>
  }

  @if (modalType == 'modalPackPermis') {
    <div class="new-modal-marketing-slider">
      <div class="padding-h-20">
        <div class="background-lecons">
          <img src="assets/2026/illustrations/onboarding-offre.png" width="219" height="206" alt="code de la route" />
        </div>
        <div class="new-modal-marketing-text">
          <h1>Prêt à prendre le volant&nbsp;?</h1>
          <p>Avec le Pack Permis, réserve des leçons où tu veux et quand tu veux&nbsp;!</p>
        </div>
      </div>

      <div class="call-center-container legacy-styles" [class.call-center-mobile]="!isPlatformDesktop">
        @if (!isPlatformDesktop) {
          <a class="call-center-link" [href]="'tel:' + callCenterPhoneFormatted">
            <div class="call-center-text-wrapper">
              <button class="btn light margin-bottom-8">Appelle-nous, c'est gratuit&nbsp;!</button>
            </div>
          </a>
        }
        @if (isPlatformDesktop) {
          <div class="call-center-text-wrapper">
            <div class="call-center-title">Des questions sur le Pack Permis&nbsp;?</div>
            <div class="call-center-desc">
              Appelle le <span class="highlight-orange">{{ callCenterPhone }}</span
              ><span class="lowlight"> (appel gratuit)</span>
            </div>
          </div>
        }
      </div>

      <div class="btn-new-modal-marketing btn-new-modal-marketing-secondary btn content-center">
        <a [href]="'tel:' + callCenterPhoneFormatted" class="text-container">Appelle-nous c’est gratuit</a>
      </div>
      <div class="btn-new-modal-marketing btn content-center" (click)="openLink('tunnelpaiementv2')">
        <div class="text-container">Découvrir le Pack Permis</div>
      </div>
    </div>
  }

  <!-- MARKETING PUB ENTRAINEMENTS -->
  @if (modalType == 'modalPubEntrainenements') {
    <div class="modal-pub-v2 content-center flex-column">
      <div class="top-part">
        <img src="assets/svg/bgModalPub.svg" alt="En Voiture Simone" />
        <div class="titles">
          <h2 class="title">
            <b class="color5"
              >{{ counter }}
              @if (counter > 1) {
                bonnes réponses
              } @else {
                bonne réponse
              }
              &nbsp;!</b
            ><br />Bientôt prêt pour la
            <b class="color2">conduite&nbsp;?</b>
          </h2>
        </div>
        <div class="car"></div>
      </div>
      <div class="bottom-part">
        <div class="texts">En plus du code,<br />En Voiture Simone t'accompagne<br />pour décrocher le permis</div>
        <div class="buttons">
          <button class="btn light full-width margin-bottom-10" (click)="closeModalPack()">Continuer l'entraînement</button>
          <button class="btn full-width" (click)="openLink('permis')">En savoir plus</button>
        </div>
      </div>
    </div>
  }

  <!-- MARKETING SERIE REGISTERED -->
  @if (modalType == 'modalPermisSerie') {
    <div class="modal-pub-v2 content-center flex-column">
      <div class="top-part">
        <img src="assets/svg/bgModalPub.svg" alt="En Voiture Simone" />
        <div class="titles">
          @if (randomTxtSerieRegistered == 1) {
            <h2 class="title">"Veni, <b class="color5">vidi</b>, <b class="color2">Pack Permis</b>"<br /><br />Jules César</h2>
          }
          @if (randomTxtSerieRegistered == 2) {
            <h2 class="title">
              En achetant <b class="color1">tout de suite</b> le <b class="color2">Pack Permis</b>, tu bénéficies de <b class="color3">nouveautés</b> aussi sur
              le
              <b class="color1">Code</b>
            </h2>
          }
          @if (randomTxtSerieRegistered == 3) {
            <h2 class="title">
              Ceci est une <b class="color4">information</b> pour te <b class="color5">rappeler</b> que nous vendons le
              <b class="color2">Pack Permis</b>
            </h2>
          }
          @if (randomTxtSerieRegistered == 4) {
            <h2 class="title">
              Il n'y a pas que les <b class="color5">séries</b> dans la <b class="color6">vie</b>,<br />il y a <b class="color5">aussi</b> le
              <b class="color2">Pack Permis</b>
            </h2>
          }
        </div>
        <div class="car"></div>
      </div>
      <div class="bottom-part">
        <div class="texts callout"><b>Envie de passer le permis&nbsp;?</b>Pense au Pack Permis.<br />{{ packPermisPrice }}€ seulement</div>
        <div class="buttons">
          <button class="btn light white full-width margin-bottom-10" (click)="closeModalPack()">Plus tard</button>
          <button class="btn full-width" (click)="openLink('permis')">En savoir plus</button>
        </div>
      </div>
    </div>
  }

  <!-- MODAL 500 -->
  @if (modalType == 'modalTimeout') {
    <div class="modal-errors content-center padding-20">
      <div class="simone-spinner">
        <div class="wrapper simone-wrapper--animate">
          <img
            src="assets/2026/illustrations/simone-happy.png"
            class="h-[40px] z-1 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            alt="Simone contente" />
          <div class="loading-circle"></div>
        </div>
      </div>
      <p>
        <span>Hmm, quelque chose semble prendre plus longtemps que prévu…<br />Merci de patienter</span>
      </p>
    </div>
  }

  <!-- MODAL STORAGE 1 -->
  @if (modalType == 'modalStorage1' || modalType == 'modalStorage2' || modalType == 'modalStorage3') {
    <div class="modal-storage content-center padding-20">
      <img class="h-[200px]" src="assets/2026/illustrations/reset-stats.png" alt="Panneau attention" />
      <h3><b>Plus de place&nbsp;!</b></h3>
      <p>Oups&nbsp;! Tu n'as plus assez d'espace sur ton appareil et certaines fonctionnalités ont été bloquées.</p>
      @if (modalType == 'modalStorage1') {
        <p>Une fois le ménage fait dans ton stockage (au moins 25Mo), clique sur le bouton pour redémarrer ton application&nbsp;!</p>
      }
      @if (modalType == 'modalStorage2' || modalType == 'modalStorage3') {
        <p>Fait de la place (au moins 25Mo), pour débloquer tes fonctionnalités</p>
      }
      @if (modalType == 'modalStorage1') {
        <button class="btn margin-top-20" (click)="goToCheckDiskSpace1()">J'ai fait de la place</button>
      }
      @if (modalType == 'modalStorage2') {
        <button class="btn margin-top-20" (click)="goToCheckDiskSpace2()">Compris</button>
      }
      @if (modalType == 'modalStorage3') {
        <button class="btn margin-top-20" (click)="closeModalPack()">Compris</button>
      }
    </div>
  }

  <!-- MODAL STORAGE 4 -->
  @if (modalType == 'modalStorage4') {
    <div class="modal-storage content-center padding-20">
      <img class="h-[200px]" src="assets/2026/illustrations/reset-stats.png" alt="Panneau attention" />
      <h3><b>Plus de place&nbsp;!</b></h3>
      <p>Il semblerait que tu n'aies pas assez d'espace disque disponible pour télécharger la dernière version.</p>
      <p>Libère au moins 25 Mo sur ton appareil avant de réessayer.</p>
      <button class="btn margin-top-20" (click)="reloadApp()">Réessayer</button>
      <!--  <div class="broom">
        <img src="assets/png/broom.png" alt="broom">
      </div> -->
    </div>
  }

  <!-- MODAL 500 -->
  @if (modalType == 'modal500') {
    <div class="modal-errors content-center padding-20">
      <img class="h-[200px]" src="assets/2026/illustrations/delete-account.png" alt="Panneau Simone Barré" />

      <p><span>Nous ne sommes pas parvenus à récupérer tes données...</span></p>
      <button class="btn margin-top-20" (click)="goToAccueil()">Retour à l'accueil</button>
    </div>
  }

  <!-- MODAL IMPAYES -->
  @if (modalType == 'modalImpayes') {
    <div class="modal-impayes content-center padding-20">
      <div class="content">
        <img class="h-[200px]" src="assets/2026/illustrations/reservation-ko.png" alt="En Voiture Simone" />
        <h3><b>Tu es en impayé</b></h3>
        <p>Il semblerait que nous ayons un problème avec l’échéance de l’un de tes paiements.</p>
        <p>Nous avons bloqué ton accès à certaines fonctionnalités. Régularise ta situation pour y accéder de nouveau.</p>
        <button class="btn light white wpe-100 margin-top-20" (click)="openLink('zendesk')">Contacter le service client</button>
        <button class="btn wpe-100 margin-top-10" (click)="goToRegulariser()">Régulariser ma situation</button>
      </div>
    </div>
  }

  <!-- MARKETING ACHATS -->
  @if (modalType == 'modalAchats') {
    <div class="modal-achats text-left align-left">
      <h3 class="margin-bottom-40">À quoi correspondent mes crédits ?</h3>

      <h4>EXAMEN DU CODE</h4>
      <p>Tu devras t'acquitter d'une somme fixe de 30€ qui sera reversée directement à la Poste pour l'organisation de ton examen du code de la route.</p>
      <h4>HEURES DE CONDUITE</h4>
      <p>
        Tu dépenses tes heures lors des leçons de conduite que tu effectues avec nos moniteurs.<br />Ces heures de conduite serviront également pour ton examen
        de la conduite.
      </p>
    </div>
  }

  <!-- SERIES GUEST -->
  @if (modalType == 'modalSeriesGuest') {
    <div class="marketing-register-modal">
      <div class="evs-logo" [class.animated]="!isCordova && isDesktop" [class.fadeIn]="!isCordova && isDesktop">
        <img src="assets/img/logo-inline.svg" alt="En Voiture Simone" />
      </div>

      <h3 class="margin-bottom-40">Connecte-toi gratuitement pour continuer et accéder à 100% des questions.</h3>

      <button class="btn light white full-width margin-bottom-10" (click)="openLink('login/signIn')">Me connecter</button>
      <button class="btn full-width" (click)="openLink('login/register')">Créer un compte gratuit</button>
    </div>
  }

  <!-- MARKETING REGISTER -->
  @if (modalType == 'marketingRegister') {
    <div class="marketing-register-modal">
      <div class="evs-logo" [class.animated]="!isCordova && isDesktop" [class.fadeIn]="!isCordova && isDesktop">
        <img src="assets/img/logo-inline.svg" alt="En Voiture Simone" />
      </div>

      <h3 class="margin-bottom-40">Crée ton compte pour profiter gratuitement de cette fonctionnalité.</h3>

      <button class="btn light white full-width margin-bottom-10" (click)="openLink('login/signIn')">Me connecter</button>
      <button class="btn full-width" (click)="openLink('login/register')">Créer un compte gratuit</button>
    </div>
  }

  <!-- MARKETING REGULAR -->
  @if (modalType == 'marketingRegular') {
    <div class="new-modal-marketing-slider">
      <div class="padding-h-20">
        <div class="background-avis">
          <img src="assets/2026/illustrations/notation.png" width="208" height="146" alt="code de la route" />
        </div>
        <div class="new-modal-marketing-text">
          <h1>Passe la seconde</h1>
          <p>Cette fonctionnalité est réservée aux élèves ayant souscrit au Pack Permis</p>
        </div>
      </div>

      <div class="call-center-container legacy-styles" [class.call-center-mobile]="!isPlatformDesktop">
        @if (!isPlatformDesktop) {
          <a class="call-center-link" [href]="'tel:' + callCenterPhoneFormatted">
            <div class="call-center-text-wrapper">
              <button class="btn light margin-bottom-8">Appelle-nous, c'est gratuit&nbsp;!</button>
            </div>
          </a>
        }
        @if (isPlatformDesktop) {
          <div class="call-center-text-wrapper">
            <div class="call-center-title">Des questions sur le Pack Permis&nbsp;?</div>
            <div class="call-center-desc">
              Appelle le <span class="highlight-orange">{{ callCenterPhone }}</span
              ><span class="lowlight"> (appel gratuit)</span>
            </div>
          </div>
        }
      </div>

      <div class="btn-new-modal-marketing btn content-center" (click)="openLink('permis')">
        <div class="text-container">Découvrir le Pack Permis</div>
      </div>
    </div>
  }
  <!-- MARKETING REGULAR LIVRET CDR -->
  @if (modalType == 'marketingRegularLivretCDR') {
    <div class="new-modal-marketing-slider">
      <div class="padding-h-20">
        <div class="background-avis">
          <img src="assets/2026/illustrations/pub-livre-code.png" width="219" height="206" alt="code de la route" />
        </div>
        <div class="new-modal-marketing-text">
          <h1>Passe la seconde</h1>
          <p>Achète le Pack Permis, et reçois gratuitement notre livre de code.<br />240 pages de bonheur qui se lisent aussi bien qu'Harry Potter.</p>
        </div>
      </div>

      <div class="call-center-container legacy-styles" [class.call-center-mobile]="!isPlatformDesktop">
        @if (!isPlatformDesktop) {
          <a class="call-center-link" [href]="'tel:' + callCenterPhoneFormatted">
            <div class="call-center-text-wrapper">
              <button class="btn light margin-bottom-8">Appelle-nous, c'est gratuit&nbsp;!</button>
            </div>
          </a>
        }
        @if (isPlatformDesktop) {
          <div class="call-center-text-wrapper">
            <div class="call-center-title">Des questions sur le Pack Permis&nbsp;?</div>
            <div class="call-center-desc">
              Appelle le <span class="highlight-orange">{{ callCenterPhone }}</span
              ><span class="lowlight"> (appel gratuit)</span>
            </div>
          </div>
        }
      </div>
      <!-- TODO should solve the click issue for the anchor with .btn-modal -->
      <div class="btn-new-modal-marketing btn-new-modal-marketing-secondary btn content-center">
        <a [href]="'tel:' + callCenterPhoneFormatted" class="text-container">Appelle-nous c’est gratuit</a>
      </div>
      <div class="btn-new-modal-marketing btn content-center" (click)="openLink('tunnelpaiementv2')">
        <div class="text-container">Découvrir le Pack Permis</div>
      </div>
    </div>
  }

  <!-- MARKETING REGULAR 1H OFFRES-->
  @if (modalType == 'marketingRegularOneHourOffres') {
    <div class="new-modal-marketing-slider">
      <div class="padding-h-20">
        <div class="background-avis">
          <img src="assets/2026/illustrations/notation.png" width="208" height="146" alt="code de la route" />
        </div>
        <div class="new-modal-marketing-text">
          <h1>Passe la seconde</h1>
          <p>Cette fonctionnalité est réservée aux élèves ayant souscrit à au moins 1 heure de conduite.</p>
        </div>
      </div>

      <div class="btn-new-modal-marketing btn content-center" (click)="openLink('offres')">
        <div class="text-container">Découvrir toutes nos offres</div>
        <!-- <i class="icon ion-ios-arrow-forward block-right margin-right-5"></i> -->
        <!-- <img class="block-right margin-right-5" src="assets/svg/arrowRightWhite.svg" alt="EnVoitureSimone" height="20"> -->
      </div>
    </div>
  }

  <!-- OLD MARKETING REGULAR -->
  @if (modalType == 'oldMarketingRegular') {
    <div class="marketing-regular-modal">
      <h3>Passe la seconde</h3>
      <p>Retrouve cette fonctionnalité dans notre formule Code Simone</p>
      <div class="evs-card margin-v-20" (click)="openLink('code-de-la-route')">
        <div class="text-container">
          <div class="callout uppercase bold">CODE SIMONE</div>
          <div class="text-gray-shade margin-top-5">Séries personnalisées, experts à ton écoute, mode hors connexion, et bien plus encore.</div>
          <div class="price margin-top-10">
            <span class="margin-right-10"
              ><b>{{ codeSimonePrice }}€</b></span
            >
          </div>
        </div>
        <!-- <i class="icon ion-ios-arrow-forward block-right margin-right-5 text-gray-74"></i>
      <img class="block-right margin-right-5" src="assets/svg/arrowRight.svg" alt="EnVoitureSimone" height="20"> -->
      </div>
      <div class="evs-card margin-bottom-40" (click)="openLink('permis')">
        <div class="border-left-highlight"></div>
        <div class="text-container">
          <div class="callout uppercase bold">Offert avec le Pack Permis</div>
        </div>
        <!-- <i class="icon ion-ios-arrow-forward block-right margin-right-5 text-gray-74"></i> -->
        <img class="block-right margin-right-5" src="assets/svg/arrowRight.svg" alt="EnVoitureSimone" height="20" />
      </div>
    </div>
  }

  <!-- MARKETING ZENDESK -->
  @if (modalType == 'marketingZendesk') {
    <div class="new-modal-marketing-slider">
      <div class="padding-h-20">
        <div class="background-support">
          <img src="assets/2026/illustrations/pub-service-client.png" width="219" height="206" alt="code de la route" />
        </div>
        <div class="new-modal-marketing-text">
          <h1>Passe la seconde</h1>
          <p>Avec notre formule Pack Permis, un expert répond à toutes tes questions</p>
        </div>
      </div>

      <div class="call-center-container legacy-styles" [class.call-center-mobile]="!isPlatformDesktop">
        @if (!isPlatformDesktop) {
          <a class="call-center-link" [href]="'tel:' + callCenterPhoneFormatted">
            <div class="call-center-text-wrapper">
              <button class="btn light margin-bottom-8">Appelle-nous, c'est gratuit&nbsp;!</button>
            </div>
          </a>
        }
        @if (isPlatformDesktop) {
          <div class="call-center-text-wrapper">
            <div class="call-center-title">Des questions sur le Pack Permis&nbsp;?</div>
            <div class="call-center-desc">
              Appelle le <span class="highlight-orange">{{ callCenterPhone }}</span
              ><span class="lowlight"> (appel gratuit)</span>
            </div>
          </div>
        }
      </div>

      <div class="btn-new-modal-marketing btn-new-modal-marketing-secondary btn content-center">
        <a [href]="'tel:' + callCenterPhoneFormatted" class="text-container">Appelle-nous c’est gratuit</a>
      </div>
      <div class="btn-new-modal-marketing btn content-center" (click)="openLink('tunnelpaiementv2')">
        <div class="text-container">Découvrir le Pack Permis</div>
      </div>
    </div>
  }

  <!-- OLD MARKETING ZENDESK -->
  @if (modalType == 'oldMarketingZendesk') {
    <div class="marketing-zendesk-modal">
      <h3>Passe la seconde</h3>
      <p>Avec la formule Code Simone, un expert répond à toutes tes questions.</p>
      <div class="evs-card margin-v-20" (click)="openLink('code-de-la-route')">
        <div class="text-container">
          <div class="callout uppercase bold">CODE SIMONE</div>
          <div class="text-gray-shade margin-top-5">Séries personnalisées, experts à ton écoute, mode hors connexion, et bien plus encore.</div>
          <div class="price margin-top-10">
            <span class="margin-right-10"
              ><b>{{ codeSimonePrice }}€</b></span
            >
          </div>
        </div>
        <!-- <i class="icon ion-ios-arrow-forward block-right margin-right-5"></i> -->
        <img class="block-right margin-right-5" src="assets/svg/arrowRight.svg" alt="EnVoitureSimone" height="20" />
      </div>
      <div class="evs-card margin-bottom-40" (click)="openLink('permis')">
        <div class="border-left-highlight"></div>
        <div class="text-container">
          <div class="callout uppercase bold">Offert avec le Pack Permis</div>
        </div>
        <!-- <i class="icon ion-ios-arrow-forward block-right margin-right-5"></i> -->
        <img class="block-right margin-right-5" src="assets/svg/arrowRight.svg" alt="EnVoitureSimone" height="20" />
      </div>
    </div>
  }

  <!-- MARKETING EXAM CODE -->
  @if (modalType == 'marketingExamCode') {
    <div class="marketing-exam-modal">
      <h3>Passe la seconde</h3>
      <p>Réserve directement ta date d'examen dans ton compte En Voiture Simone.</p>
      <p class="small-text">Attention. La formule n'inclut le pas le coût d'inscription de 30€ pour chaque examen (tarif réglementé).</p>
      <!-- <p class="small-text">Attention. La formule n'inclut le pas le coût d'inscription de 30€ pour chaque examen (tarif réglementé).<br><a class="underline clickable" (click)="openLink('aideExamen')">Tout savoir sur l'examen du code</a></p> -->
      <div class="evs-card margin-v-20" (click)="openLink('permis')">
        <div class="text-container">
          <div class="callout uppercase bold">CODE SIMONE</div>
          <div class="text-gray-shade margin-top-5">Séries personnalisées, experts à ton écoute, mode hors connexion, et bien plus encore.</div>
          <div class="price margin-top-10">
            <span class="margin-right-10"><b>29€</b></span>
          </div>
        </div>
        <!-- <i class="icon ion-ios-arrow-forward block-right margin-right-5"></i> -->
        <img class="block-right margin-right-5" src="assets/svg/arrowRight.svg" alt="EnVoitureSimone" height="20" />
      </div>
      <div class="evs-card margin-bottom-40" (click)="openLink('permis')">
        <div class="border-left-highlight"></div>
        <div class="text-container">
          <div class="callout uppercase bold">Offert avec le Pack Permis</div>
        </div>
        <!-- <i class="icon ion-ios-arrow-forward block-right margin-right-5"></i> -->
        <img class="block-right margin-right-5" src="assets/svg/arrowRight.svg" alt="EnVoitureSimone" height="20" />
      </div>
    </div>
  }

  <!-- MARKETING EXAM CODUITE -->
  @if (modalType == 'marketingExamConduite') {
    <div class="new-modal-marketing-slider">
      <div class="padding-h-20">
        <div class="background-conduite">
          <img src="assets/2026/illustrations/pub-reserver-examen.png" alt="code de la route" />
        </div>
        <div class="new-modal-marketing-text">
          <h1>Passe la seconde</h1>
          <p>Pour réserver un accompagnement à l'examen de la conduite, tu dois avoir acheté au moins 20 leçons de conduite, ou le Pack Permis</p>
        </div>
      </div>

      <div class="call-center-container legacy-styles" [class.call-center-mobile]="!isPlatformDesktop">
        @if (!isPlatformDesktop) {
          <a class="call-center-link" [href]="'tel:' + callCenterPhoneFormatted">
            <div class="call-center-text-wrapper">
              <button class="btn light margin-bottom-8">Appelle-nous, c'est gratuit&nbsp;!</button>
            </div>
          </a>
        }
        @if (isPlatformDesktop) {
          <div class="call-center-text-wrapper">
            <div class="call-center-title">Des questions sur le Pack Permis&nbsp;?</div>
            <div class="call-center-desc">
              Appelle le <span class="highlight-orange">{{ callCenterPhone }}</span
              ><span class="lowlight"> (appel gratuit)</span>
            </div>
          </div>
        }
      </div>

      <div class="btn-new-modal-marketing btn content-center" (click)="openLink('permis')">
        <div class="text-container">Découvrir le Pack Permis</div>
      </div>
    </div>
  }

  <!-- REGISTERED -->
  @if (modalType == 'registered') {
    <div class="registered-modal">
      <img src="{{ imgRegisteredPath }}" alt="Registered please !" />
      <h3>Poursuivre l'entraînement</h3>
      <p>Tu souhaites réaliser de nouvelles séries&nbsp;? Crée gratuitement ton compte et profite de 2 séries supplémentaires&nbsp;!</p>
      <button class="btn margin-top-20" (click)="openLink('login')">Je crée mon compte</button>
    </div>
  }

  <!-- PREMIUM -->
  @if (modalType == 'premium') {
    <div class="premium-modal">
      <table class="modal-premium-title">
        <tr>
          <td><h3>Deviens élève pour un accès illimité&nbsp;!</h3></td>
          <td>
            <img class="modal-premium-visuel" src="{{ imgPremiumPath }}" alt="C'est parti" />
          </td>
        </tr>
      </table>
      <div class="modal-premium-offers">
        <div class="modal-premium-offer" [class.active-offer]="activeOffer == 'code'" (mouseover)="activeOffer = 'code'" (click)="activeOffer = 'code'">
          <div class="content">
            Formule code
            @for (offer of offers; track offer) {
              @if (offer.offer_type === 'code') {
                <span class="price"
                  ><b>{{ offer.amount }}€</b></span
                >
              }
            }
          </div>
        </div>
        <div class="modal-premium-offer" [class.active-offer]="activeOffer == 'heures'" (mouseover)="activeOffer = 'heures'" (click)="activeOffer = 'heures'">
          <div class="content">
            Heures de conduite
            @for (offer of offers; track offer) {
              @if (offer.offer_type === 'hour' && offer.min_quantity == 1) {
                <span class="price"
                  ><b>{{ offer.amount }}€</b></span
                >
              }
            }
          </div>
        </div>
        <div class="modal-premium-offer" [class.active-offer]="activeOffer == 'permis'" (mouseover)="activeOffer = 'permis'" (click)="activeOffer = 'permis'">
          <div class="content">
            Pack permis
            @for (offer of offers; track offer) {
              @if (offer.offer_type === 'big_pack') {
                <span class="price"
                  ><b>{{ offer.amount }}€</b></span
                >
              }
            }
          </div>
        </div>
      </div>
      @if (activeOffer == 'code') {
        <div class="modal-premium-offer-details">
          <ul>
            <li>Entraîne-toi à <strong>1600 questions</strong> conformes à l’examen 2019</li>
            <li>Accède à plus de <strong>140 leçons</strong> réparties en <strong>11 thématiques</strong> de cours</li>
            <li>Avance à <strong>ton rythme</strong> et suis tes progrès jour après jour</li>
            <li>
              Réserve ta place à l’examen du code
              <strong>quand tu le souhaites</strong> auprès de l’un de nos centres partenaires La Poste
            </li>
          </ul>
        </div>
        <button class="btn full-width margin-v-20" (click)="openLink('code-de-la-route')">Je passe le code</button>
      }
      @if (activeOffer == 'heures') {
        <div class="modal-premium-offer-details">
          <ul>
            <li>
              Réserve tes leçons de conduite en ligne avec nos
              <strong>enseignants diplômés</strong>
            </li>
            <li>
              Organise ta formation <strong>près de chez toi</strong>, aux créneaux qui t'arrangent, <strong>7j/7</strong> de
              <strong>7h à 23h</strong>
            </li>
            <li>
              Avance à <strong>ton rythme</strong> et réserve tes heures
              <strong>sans engagement</strong>
            </li>
            <li>Conserve <strong>le même enseignant</strong> tout au long de ta formation, ou change-en <strong>quand tu le souhaites</strong></li>
          </ul>
        </div>
        <button class="btn full-width margin-v-20" (click)="openLink('permis')">Je réserve des heures</button>
      }
      @if (activeOffer == 'permis') {
        <div class="modal-premium-offer-details">
          <ul>
            <li>Entraîne-toi à <strong>1600 questions</strong> conformes à l’examen 2019</li>
            <li>
              Réserve ta place à l’examen du code
              <strong>quand tu le souhaites</strong>
            </li>
            <li>Une fois le code en poche, réserve tes leçons de conduite en ligne avec nos <strong>enseignants diplômé</strong>s</li>
            <li>Organise ta formation <strong>près de chez toi</strong>, aux créneaux qui <strong>t'arrangent</strong>, 7j/7 de 7h à 23h</li>
          </ul>
        </div>
        <button class="btn full-width margin-v-20" (click)="openLink('permis')">Je passe le permis <span class="padding-left-10">🚀</span></button>
      }
    </div>
  }

  <!-- DRIVING PACK -->
  @if (modalType == 'drivingPack') {
    <div class="driving-modal">
      <img src="{{ imgDrivingPath }}" alt="En Voiture !" />
      <h3>
        La conduite avec <br />
        En Voiture Simone
      </h3>
      <p>
        En Voiture Simone est <strong>disponible partout</strong> en France pour le <strong>code de la route</strong>, et à <strong>Paris</strong>,
        <strong>Bordeaux</strong>, <strong>Lyon</strong>, <strong>Lille</strong>, <strong>Toulouse</strong> et <strong>Montpellier</strong> pour les
        <strong>leçons de conduite</strong>&nbsp;!
      </p>
      <p>Prépare l'examen du permis de conduire avec En Voiture Simone :</p>
      <ul class="margin-0">
        <li>
          <strong>Gère</strong> ton emploi du temps comme tu l'entends en réservant tes leçons de conduite <strong>7j/7</strong> de <strong>7h</strong> à
          <strong>23h</strong>
        </li>
        <li>Apprends à conduire auprès de nos enseignants <strong>diplômés</strong></li>
        <li>
          Démarre en bas de chez toi dans l'un de nos
          <strong>2000 points de rendez-vous</strong>
        </li>
      </ul>
      <button class="btn margin-v-20" (click)="openLink('permis')">Je m'inscris</button>
    </div>
  }

  <!-- Hour only -->
  @if (modalType == 'hourOnly') {
    <div class="hour-modal">
      <img class="img-modal-driving" src="{{ imgHourOnlyPath }}" alt="En Voiture !" />
      <h3>Envie de reprendre l'entraînement au code&nbsp;?</h3>
      <p>
        En Voiture Simone t'accompagne dans ta formation au code de la route pour être parfaitement préparé
        @if (student?.gender == 'f') {
          <span>e</span>
        }
        lorsque tu prends le volant&nbsp;!
      </p>
      <button class="btn" (click)="openLink('code')">Je révise le code</button>
    </div>
  }
</ion-content>
